import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import sistemaListStore, {
  sistemaListShowModal,
} from '~/pages/Sistema/componentes/SistemaList/ThisMainComponent/thisStore';

import ShowConfirmacao from '~/utils/ShowConfirmacao';
import { schema, buildDefaultValuesFromFuncionario, buildFuncionarioPayload } from '../formSchema';
import * as service from '../service';
import FuncionarioFormFields from '../FuncionarioFormFields';

function EditContent({ mountedData, refetch }) {
  const { dispatch } = React.useContext(sistemaListStore);

  const {
    register,
    control,
    watch,
    formState: { errors },
    handleSubmit: handleFormSubmit,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: buildDefaultValuesFromFuncionario(mountedData),
  });

  async function handleSubmit(data) {
    return ShowConfirmacao(
      async () => {
        const response = await service.update(mountedData.id, buildFuncionarioPayload(data));

        if (response?.data) {
          refetch && (await refetch());
          dispatch(sistemaListShowModal(false));
        }

        return response;
      },
      {
        message: 'Tem certeza que deseja atualizar este funcionário?',
        successModal: 'Funcionário atualizado com sucesso!',
        errorModal: {
          defaultMessage: 'Ocorreu um erro ao atualizar o funcionário. Por favor, tente novamente.',
        },
      },
    );
  }

  return (
    <SLForm onSubmit={handleFormSubmit(handleSubmit)} defaultStyle>
      <FuncionarioFormFields
        register={register}
        control={control}
        errors={errors}
        watch={watch}
        isEditing
      />
    </SLForm>
  );
}

export default EditContent;
